import { defineComponent as h, ref as T, computed as g, openBlock as l, createElementBlock as r, normalizeStyle as v, createElementVNode as e, normalizeClass as o, unref as u, toDisplayString as n, createVNode as d, createTextVNode as x, Fragment as c, renderList as y } from "vue";
import { useLandingAnimation as S } from "./index127.js";
import m from "./index60.js";
const _ = ["id"], z = { class: "relative" }, j = {
  class: "text-xs font-semibold uppercase tracking-widest",
  style: { color: "var(--landing-primary)" }
}, M = { class: "mt-3 text-3xl font-bold text-white md:text-4xl lg:text-5xl" }, L = {
  class: "mx-auto mt-4 max-w-2xl text-base md:text-lg",
  style: { color: "var(--landing-apppreview-muted)" }
}, N = { class: "landing-apppreview-tabs" }, C = { class: "grid grid-cols-1 items-center gap-12 lg:grid-cols-2" }, F = { class: "order-2 lg:order-1" }, V = ["innerHTML"], A = { class: "mt-6 space-y-3" }, H = {
  class: "text-sm",
  style: { color: "var(--landing-apppreview-item)" }
}, I = { class: "order-1 flex justify-center lg:order-2" }, D = { class: "relative w-64 md:w-72 lg:w-80" }, $ = {
  class: "relative overflow-hidden rounded-3xl border shadow-xl",
  style: { background: "var(--landing-dark-900)", "border-color": "var(--landing-dark-600)", "aspect-ratio": "9/19" }
}, B = ["src"], E = { class: "order-2 lg:order-1" }, O = ["innerHTML"], P = { class: "mt-6 space-y-3" }, W = {
  class: "text-sm",
  style: { color: "var(--landing-apppreview-item)" }
}, q = { class: "order-1 flex justify-center lg:order-2" }, G = { class: "relative w-full max-w-lg" }, J = {
  class: "relative overflow-hidden rounded-3xl border shadow-xl",
  style: { background: "var(--landing-dark-900)", "border-color": "var(--landing-dark-600)", "aspect-ratio": "16/10" }
}, K = ["src"], Y = /* @__PURE__ */ h({
  __name: "LandingAppPreview",
  props: {
    overline: {},
    title: {},
    description: {},
    mtsTitle: {},
    mtsFeatures: {},
    wtsTitle: {},
    wtsFeatures: {},
    mtsImageSrc: { default: "/images/mts-screen-1.jpg" },
    wtsImageSrc: { default: "/images/wts-preview.jpg" },
    primary: { default: "var(--base-colors-primary-primary800)" },
    bg: { default: "dark" },
    id: {}
  },
  setup(a) {
    const b = a, i = T("mts"), { el: f, isVisible: p } = S(), w = g(() => ({
      backgroundColor: "#242424",
      "--landing-primary": b.primary,
      "--landing-primary-400": "var(--base-colors-primary-primary400)",
      "--landing-dark": "#ffffff",
      "--landing-bg-light": "var(--base-colors-common-light-gray-f5)",
      "--landing-dark-900": "#0a0a0a",
      "--landing-dark-600": "#3a3a3a"
    })), k = g(() => ({
      "--landing-apppreview-muted": "#9ca3af",
      "--landing-apppreview-item": "#d1d5db",
      "--landing-apppreview-inactive-tab": "#9ca3af"
    }));
    return (Q, t) => (l(), r("section", {
      id: a.id,
      class: "landing-apppreview-section py-16 md:py-20 lg:py-24",
      style: v(w.value)
    }, [
      e("div", {
        ref_key: "el",
        ref: f,
        style: v(k.value),
        class: "relative mx-auto max-w-7xl overflow-hidden px-4 sm:px-6 lg:px-8"
      }, [
        e("div", z, [
          e("div", {
            class: o(["mb-12 text-center transition-all duration-700", u(p) ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"])
          }, [
            e("span", j, n(a.overline), 1),
            e("h2", M, n(a.title), 1),
            e("p", L, n(a.description), 1)
          ], 2),
          e("div", {
            class: o(["mb-10 flex justify-center transition-all duration-700", u(p) ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"])
          }, [
            e("div", N, [
              e("button", {
                type: "button",
                class: o(["landing-apppreview-tab", { "landing-apppreview-tab--active": i.value === "mts" }]),
                onClick: t[0] || (t[0] = (s) => i.value = "mts")
              }, [
                d(m, {
                  name: "iphone",
                  size: 16,
                  className: "shrink-0"
                }),
                t[2] || (t[2] = x(" MTS 모바일 ", -1))
              ], 2),
              e("button", {
                type: "button",
                class: o(["landing-apppreview-tab", { "landing-apppreview-tab--active": i.value === "wts" }]),
                onClick: t[1] || (t[1] = (s) => i.value = "wts")
              }, [
                d(m, {
                  name: "desktop",
                  size: 16,
                  className: "shrink-0"
                }),
                t[3] || (t[3] = x(" WTS 웹 ", -1))
              ], 2)
            ])
          ], 2),
          e("div", C, [
            i.value === "mts" ? (l(), r(c, { key: 0 }, [
              e("div", F, [
                t[4] || (t[4] = e("span", {
                  class: "text-xs font-semibold uppercase tracking-widest",
                  style: { color: "var(--landing-primary)" }
                }, " Mobile Trading System ", -1)),
                e("h3", {
                  class: "mt-3 text-3xl font-bold text-white md:text-4xl",
                  innerHTML: a.mtsTitle
                }, null, 8, V),
                t[5] || (t[5] = e("p", {
                  class: "mt-4 text-base leading-relaxed",
                  style: { color: "var(--landing-apppreview-muted)" }
                }, " 깔끔하고 직관적인 인터페이스로 글로벌 투자가 이렇게 쉬워져요. ", -1)),
                e("ul", A, [
                  (l(!0), r(c, null, y(a.mtsFeatures, (s) => (l(), r("li", {
                    key: s,
                    class: "flex items-start gap-3"
                  }, [
                    d(m, {
                      name: "check-mark",
                      size: 20,
                      color: "var(--landing-primary)",
                      className: "shrink-0 mt-0.5"
                    }),
                    e("span", H, n(s), 1)
                  ]))), 128))
                ])
              ]),
              e("div", I, [
                e("div", D, [
                  e("div", $, [
                    e("img", {
                      src: a.mtsImageSrc,
                      alt: "MODA 모바일 트레이딩 화면",
                      class: "h-full w-full object-cover object-top",
                      loading: "lazy"
                    }, null, 8, B),
                    t[6] || (t[6] = e("div", {
                      class: "absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/20",
                      "aria-hidden": "true"
                    }, null, -1))
                  ]),
                  t[7] || (t[7] = e("div", {
                    class: "absolute -inset-4 -z-10 rounded-3xl blur-2xl",
                    style: { background: "color-mix(in srgb, var(--landing-primary) 5%, transparent)" }
                  }, null, -1))
                ])
              ])
            ], 64)) : (l(), r(c, { key: 1 }, [
              e("div", E, [
                t[8] || (t[8] = e("span", {
                  class: "text-xs font-semibold uppercase tracking-widest",
                  style: { color: "var(--landing-primary)" }
                }, " Web Trading System ", -1)),
                e("h3", {
                  class: "mt-3 text-3xl font-bold text-white md:text-4xl",
                  innerHTML: a.wtsTitle
                }, null, 8, O),
                t[9] || (t[9] = e("p", {
                  class: "mt-4 text-base leading-relaxed",
                  style: { color: "var(--landing-apppreview-muted)" }
                }, " 데스크톱에서 더 넓은 화면으로 정밀한 분석과 거래를 경험하세요. ", -1)),
                e("ul", P, [
                  (l(!0), r(c, null, y(a.wtsFeatures, (s) => (l(), r("li", {
                    key: s,
                    class: "flex items-start gap-3"
                  }, [
                    d(m, {
                      name: "check-mark",
                      size: 20,
                      color: "var(--landing-primary)",
                      className: "shrink-0 mt-0.5"
                    }),
                    e("span", W, n(s), 1)
                  ]))), 128))
                ])
              ]),
              e("div", q, [
                e("div", G, [
                  e("div", J, [
                    e("img", {
                      src: a.wtsImageSrc,
                      alt: "MODA 데스크톱 트레이딩 화면",
                      class: "h-full w-full object-cover object-top",
                      loading: "lazy"
                    }, null, 8, K),
                    t[10] || (t[10] = e("div", {
                      class: "absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/20",
                      "aria-hidden": "true"
                    }, null, -1))
                  ]),
                  t[11] || (t[11] = e("div", {
                    class: "absolute -inset-4 -z-10 rounded-3xl blur-2xl",
                    style: { background: "color-mix(in srgb, var(--landing-primary) 5%, transparent)" }
                  }, null, -1))
                ])
              ])
            ], 64))
          ])
        ])
      ], 4)
    ], 12, _));
  }
});
export {
  Y as default
};
